module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "search": {
        "type": "string",
        "isOptional": true
      },
      "pathname": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "connect-dot-com-ui",
    "version": "1"
  },
  "interaction": {
    "name": "connect dot com interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "name": {
        "type": "string",
        "isOptional": true
      },
      "entryPoint": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "connect-dot-com-ui",
    "version": "1"
  }
};